/**
 * Storage scales for every fixed-unit value in the calculation engine.
 *
 * Nothing in the money path uses IEEE-754 floating point. Every monetary and
 * quantitative value is an INTEGER in a defined unit, which is why
 * 0.1 + 0.2 problems cannot arise and why a figure like the legacy
 * `cgst: 17743.7286` found in DNR Vyapar 1.6.x production data is
 * unrepresentable here.
 *
 * See design §5.11.
 */
export const SCALES = {
  /** Money: 1 unit = 1 paise. ₹1,23,456.78 is stored as 12345678. */
  money: 1,

  /**
   * Quantity: 1 unit = 0.001 of the base unit (milli-units).
   * 0.75 Kg is stored as 750.
   */
  quantity: 1000,

  /** Tax rate: 1 unit = 0.01% (basis points). 18% is stored as 1800. */
  basisPoints: 10_000,

  /** Discount percentage: 1 unit = 0.001%. 12.5% is stored as 12500. */
  percentMilli: 100_000,

  /** Exchange rate: 1 unit = 0.001. 83.25 is stored as 83250. */
  rateMilli: 1000,
} as const;

export type ScaleName = keyof typeof SCALES;
